import { Router } from '@angular/router';
import { DocumentsErrorCodes } from '@app/translations';
import { AlertHandlerService } from '@finxone-platform/shared/services';
import { Store } from '@ngxs/store';
import { findAndShowAlertFromCode } from '../alert-code-utils/alert-code.utils';

// File.size is in bytes, so limits are expressed in bytes too: 20 * 1024 * 1024.
export const MAX_UPLOAD_FILE_SIZE_BYTES = 20971520; // 20MB

/**
 * Rejects oversized files before any request is made, so the user gets the specific
 * file-size alert instead of it plus a generic upload/HTTP failure alert.
 */
export function isFileSizeWithinLimit(
  file: File,
  store: Store,
  router: Router,
  alertHandlerService: AlertHandlerService,
  maxFileSizeBytes: number = MAX_UPLOAD_FILE_SIZE_BYTES,
): boolean {
  if (file.size <= maxFileSizeBytes) return true;

  findAndShowAlertFromCode(store, router, alertHandlerService, [
    DocumentsErrorCodes.DOCUMENT_FILE_SIZE_EXCEEDED,
  ]);

  return false;
}
